import store from '../store/index'
import router from '@/router'

export default (req, next) => {
  return ({ status }) => {
    if (status === 401) {
      store.dispatch('auth/ActionSignOut')
      router.push({ path: '/auth' })
    }
    next()
  }
}
